var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.purchase.block_info
    ? _c("div", [
        _vm.purchase.block_info.blocked_at
          ? _c(
              "p",
              {
                staticClass:
                  "d-flex align-items-center text-danger fw-600 fs-12 my-2",
              },
              [
                _vm._v(
                  "Заблокировано " +
                    _vm._s(
                      _vm.getDateTimeFormat(_vm.purchase.block_info.blocked_at)
                    )
                ),
              ]
            )
          : _vm._e(),
        _vm.purchase.block_info.message
          ? _c(
              "p",
              {
                staticClass:
                  "d-flex align-items-center text-danger fw-600 fs-12 mt-2 mb-0",
              },
              [_vm._v("Причина блокировки:")]
            )
          : _vm._e(),
        _vm.purchase.block_info.message
          ? _c(
              "p",
              {
                staticClass: "d-flex align-items-center text-danger fs-12 my-0",
              },
              [_vm._v(_vm._s(_vm.purchase.block_info.message))]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }